import { formatMoney } from '@shopify/theme-currency/currency'
import 'whatwg-fetch'
import serialize from 'form-serialize'
import da from 'vanillajs-datepicker/locales/da'

export default class GoCart {
  constructor(options) {
    const defaults = {
      cartModalFail: '.js-go-cart-modal-fail',
      cartModalFailClose: '.js-go-cart-modal-fail-close',
      cartModal: '.js-go-cart-modal',
      cartModalClose: '.js-go-cart-modal-close',
      cartModalContent: '.js-go-cart-modal-content',
      cartDrawer: '.js-go-cart-drawer',
      cartDrawerContent: '.js-go-cart-drawer-content',
      cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
      cartDrawerFooter: '.js-go-cart-drawer-footer',
      cartDrawerClose: '.js-go-cart-drawer-close',
      cartMiniCart: '.js-go-cart-mini-cart',
      cartMiniCartContent: '.js-go-cart-mini-cart-content',
      cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
      cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
      cartTrigger: '.js-go-cart-trigger',
      cartOverlay: '.js-go-cart-overlay',
      cartCount: '.js-go-cart-counter',
      addToCart: '.js-go-cart-add-to-cart',
      removeFromCart: '.js-go-cart-remove-from-cart',
      removeFromCartNoDot: 'js-go-cart-remove-from-cart',
      itemQuantity: '.js-go-cart-quantity',
      itemQuantityPlus: '.js-go-cart-quantity-plus',
      itemQuantityMinus: '.js-go-cart-quantity-minus',
      cartMode: 'drawer',
      drawerDirection: 'right',
      upsellContainer: '.js-upsell-container',
      displayModal: false,
      moneyFormat: '${{amount}}',
      productRecommendations: '.js-pdp-recommendations',
    }

    this.defaults = Object.assign({}, defaults, options)

    this.cartModalFail = document.querySelector(this.defaults.cartModalFail)
    this.cartModalFailClose = document.querySelector(
      this.defaults.cartModalFailClose
    )
    this.cartModal = document.querySelector(this.defaults.cartModal)
    this.cartModalClose = document.querySelectorAll(
      this.defaults.cartModalClose
    )
    this.cartModalContent = document.querySelector(
      this.defaults.cartModalContent
    )
    this.cartDrawer = document.querySelector(this.defaults.cartDrawer)
    this.cartDrawerContent = document.querySelector(
      this.defaults.cartDrawerContent
    )
    this.cartDrawerSubTotal = document.querySelector(
      this.defaults.cartDrawerSubTotal
    )
    this.cartDrawerFooter = document.querySelector(
      this.defaults.cartDrawerFooter
    )
    this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose)
    this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart)
    this.cartMiniCartContent = document.querySelector(
      this.defaults.cartMiniCartContent
    )
    this.cartMiniCartSubTotal = document.querySelector(
      this.defaults.cartMiniCartSubTotal
    )
    this.cartMiniCartFooter = document.querySelector(
      this.defaults.cartMiniCartFooter
    )
    this.cartTrigger = document.querySelector(this.defaults.cartTrigger)
    this.cartOverlay = document.querySelector(this.defaults.cartOverlay)
    this.cartCount = document.querySelector(this.defaults.cartCount)
    this.addToCart = document.querySelectorAll(this.defaults.addToCart)
    this.removeFromCart = this.defaults.removeFromCart
    this.removeFromCartNoDot = this.defaults.removeFromCartNoDot
    this.itemQuantity = this.defaults.itemQuantity
    this.itemQuantityPlus = this.defaults.itemQuantityPlus
    this.itemQuantityMinus = this.defaults.itemQuantityMinus
    this.cartMode = this.defaults.cartMode
    this.drawerDirection = this.defaults.drawerDirection
    this.displayModal = this.defaults.displayModal
    this.moneyFormat = this.defaults.moneyFormat
    this.upsellContainer = document.querySelector(this.defaults.upsellContainer)
    this.productRecommendations = document.querySelector(
      this.defaults.productRecommendations
    )

    this.init()
  }

  get isDrawerMode() {
    return this.cartMode === 'drawer'
  }

  init() {
    this.fetchCart()

    if (this.isDrawerMode) {
      this.setDrawerDirection()
    }

    if (this.productRecommendations) {
      this.productRecommendations.addEventListener('click', (e) => {
        if (e.target.classList.contains('js-go-cart-add-to-cart')) {
          e.preventDefault()
          const formID = e.target.parentNode.parentNode.getAttribute('id')
          this.addItemToCart(formID)
        }
      })
    }

    this.addToCart.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault()
        if (item.disabled !== 'disabled') {
          const formID = item.parentNode.parentNode.getAttribute('id')
          this.addItemToCart(formID)
        }
      })
    })

    this.cartTrigger.addEventListener('click', () => {
      if (this.isDrawerMode) {
        this.openCartDrawer()
        document.querySelector('html').style.overflowY = 'hidden'
      } else {
        this.openMiniCart()
      }
      this.openCartOverlay()
    })

    this.cartOverlay.addEventListener('click', () => {
      this.closeFailModal()
      this.closeCartModal()
      document.querySelector('html').style.overflowY = 'auto'
      if (this.isDrawerMode) {
        this.closeCartDrawer()
      } else {
        this.closeMiniCart()
      }
      this.closeCartOverlay()
    })

    if (this.isDrawerMode) {
      this.cartDrawerClose.addEventListener('click', () => {
        this.closeCartDrawer()
        this.closeCartOverlay()
        document.querySelector('html').style.overflowY = 'auto'
      })
    }

    if (this.displayModal) {
      this.cartModalClose.forEach((item) => {
        item.addEventListener('click', () => {
          this.closeFailModal()
          this.closeCartModal()
          if (this.isDrawerMode) {
            this.closeCartDrawer()
          } else {
            this.closeMiniCart()
          }
          this.closeCartOverlay()
        })
      })
    }

    this.cartModalFailClose.addEventListener('click', () => {
      this.closeFailModal()
      this.closeCartModal()
      if (this.isDrawerMode) {
        this.closeCartDrawer()
      } else {
        this.closeMiniCart()
      }
      this.closeCartOverlay()
    })
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('js-replace-with-selling-plan')) {
        let sel = e.target
        let id = sel.options[sel.selectedIndex].value
        let line = sel.closest('.go-cart-item__single').dataset.line

        if (
          sel.options[sel.selectedIndex].getAttribute('current-selected') ===
          null
        ) {
          this.replaceItem(line, id, sel.dataset.variant, 1)
        }
      }
    })

    document.addEventListener('click', (c) => {
      if (c.target.classList.contains('js-subscribe-btn')) {
        let variant = c.target.dataset.variant
        let line = c.target.closest('.go-cart-item__single').dataset.line
        let id = c.target.dataset.plan
        this.replaceItem(line, id, variant, 1)
      }
    })
  }

  fetchCart(callback) {
    window
      .fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
      })
      .then((response) => response.json())
      .then((cart) => this.fetchHandler(cart, callback))
      .catch((error) => {
        this.ajaxRequestFail()
        throw new Error(error)
      })
  }

  addItemToCart(formID) {
    const form = document.querySelector(`#${formID}`)
    const formData = serialize(form, { hash: true })
    window
      .fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((product) => this.addItemToCartHandler(product))
      .catch((error) => {
        this.ajaxRequestFail()
        throw new Error(error)
      })
    //Reset qty to 1
    form.querySelector('input[name="quantity"]').value = 1
  }

  removeItem(line) {
    const quantity = 0
    window
      .fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify({ quantity, line }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.json())
      .then(() => this.fetchCart())
      .catch((error) => {
        this.ajaxRequestFail()
        throw new Error(error)
      })
  }

  replaceItem(line, planId, id, qty, cpage = false) {
    const quantity = 0
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({ quantity, line }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((res) => {
        this.addSellingItem(planId, id, qty, cpage)
      })
      .catch((error) => {
        this.ajaxRequestFail()
        throw new Error(error)
      })
  }

  addSellingItem(planId, id, qty, cpage) {
    let data = {
      id: id,
      selling_plan: planId,
      quantity: 1,
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((product) => {
        if (cpage) {
          window.location.reload()
        } else {
          this.fetchCart()
        }
      })
      .catch((error) => {
        console.log(error)
        throw new Error(error)
      })
  }

  changeItemQuantity(line, quantity) {
    window
      .fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify({ quantity, line }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.json())
      .then(() => this.fetchCart())
      .catch((error) => {
        this.ajaxRequestFail()
        throw new Error(error)
      })
  }

  cartItemCount(cart) {
    this.cartCount.innerHTML = cart.item_count
    cart_item_count = cart.item_count
    if (cart.item_count == 0) {
      this.cartCount.classList.add('empty')
      this.cartCount.classList.remove('number')
    } else {
      this.cartCount.classList.remove('empty')
      this.cartCount.classList.add('number')
    }
  }

  fetchAndOpenCart() {
    this.fetchCart(() => {
      if (this.isDrawerMode) {
        this.openCartDrawer()
      } else {
        this.openMiniCart()
      }
      this.openCartOverlay()
    })
  }

  fetchAndOpenModal(product) {
    this.fetchCart(() => {
      this.renderCartModal(product)
      this.openCartModal()
      this.openCartOverlay()
    })
  }

  fetchHandler(cart, callback) {
    this.cartItemCount(cart)
    if (this.isDrawerMode) {
      if (cart.item_count === 0) {
        this.renderBlankCartDrawer()
        this.cartDrawerFooter.classList.add('is-invisible')
      } else {
        this.renderDrawerCart(cart)
        this.cartDrawerFooter.classList.remove('is-invisible')
        if (typeof callback === 'function') {
          callback(cart)
        }
      }
    } else if (cart.item_count === 0) {
      this.renderBlankMiniCart()
      this.cartMiniCartFooter.classList.add('is-invisible')
    } else {
      this.renderMiniCart(cart)
      this.cartMiniCartFooter.classList.remove('is-invisible')
      if (typeof callback === 'function') {
        callback(cart)
      }
    }
  }

  addItemToCartHandler(product) {
    return this.displayModal
      ? this.fetchAndOpenModal(product)
      : this.fetchAndOpenCart()
  }

  getUpsellProduct(handles) {
    let id = ''
    let exist = false
    let length = upsellArray.length
    let used = 0

    for (let i = 0; i < upsellArray.length; i++) {
      exist = false
      let handle = upsellArray[i]
      for (let x = 0; x < handles.length; x++) {
        if (handles[x] == handle) {
          id = handles[x]
          exist = true
          used = used + 1
        }
      }

      if (!exist) {
        id = upsellArray[i]
        break
      }
    }
    if (used === length) {
      if (window.innerWidth < 767) {
        this.cartDrawerFooter.style.position = 'absolute'
        this.cartDrawerFooter.style.bottom = '0'
      }
      this.upsellContainer.style.display = 'none'
      let cfHeight = this.cartDrawerFooter.clientHeight
      let height = window.innerHeight - cfHeight
      this.cartDrawerContent.style.height = `${height}px`
    } else {
      if (window.innerWidth < 767) {
        this.cartDrawerFooter.style.position = 'absolute'
        this.cartDrawerFooter.style.bottom = '0'
      }
      this.upsellContainer.style.display = 'block'
      let cfHeight = this.cartDrawerFooter.clientHeight
      if (this.cartDrawer.classList.contains('is-rcsms')) {
        cfHeight = this.cartDrawerFooter.clientHeight - 48
      } else {
        cfHeight = this.cartDrawerFooter.clientHeight
      }
      let height = window.innerHeight - cfHeight - 230
      this.cartDrawerContent.style.height = `${height}px`
    }
    return id
  }

  getUpsellProductContent(id) {
    // console.log(id)

    fetch('/products/' + id + '.json', {
      credentials: 'same-origin',
      method: 'GET',
    })
      .then((response) => response.json())
      .then((product) => {
        this.renderUpsell(product.product)
      })
  }

  ajaxRequestFail() {
    this.openFailModal()
    this.openCartOverlay()
  }

  renderCartModal(product) {
    this.clearCartModal()
    let productVariant = product.variant_title
    if (productVariant === null) {
      productVariant = ''
    } else {
      productVariant = `(${productVariant})`
    }
    const cartSingleProduct = `
        <div class="go-cart-modal-item">
            <a href="${product.url}"><div class="go-cart-item__image" style="background-image: url(${product.image});"></div></a>
            <div class="go-cart-item__info">
                <a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a> was added to your cart.
            </div>
        </div>
      `
    this.cartModalContent.innerHTML += cartSingleProduct
  }

  renderUpsell(product) {
    window.upsellText = ''
    if (cart_item_count == 0) {
      window.upsellText = 'You might like'
    } else {
      window.upsellText = 'You might also want'
    }
    let productVariant = product.variants[0]
    const upsellContent = `
    <div class="go-card-also-want">
    <h3 class="sub-h4 js-upsell-title">${upsellText}</h3>
    <div class="go-card-also-want__inner">
      <div class="go-card-also-want__item">
      <a href="/products/${product.handle}">
          <div class="go-card-also-want__image" style="background-image: url(${
            product.image.src
          });">
          </div></a>
          <div class="go-card-also-want__content">
            <a href="/products/${product.handle}" class="title">${
      product.title
    }</a>
            <span class="price">${formatMoney(
              productVariant.price,
              this.moneyFormat
            )}
          </div>
          <form class="upsell" id="upsell_form">
            <input type="hidden"
            name="quantity" value="1" />
            <input type="hidden" name="id" value="${productVariant.id}">
            <div class="go-card-also-want__cta">
                <button class="btn btn--primary js-upsell-add-to-cart">ADD</button>
            </div>
          </form>
          </div>
        </div>
      </div>
    `
    this.upsellContainer.innerHTML = upsellContent
    let upsellAddToCart = document.querySelector('.js-upsell-add-to-cart')

    upsellAddToCart.addEventListener('click', (e) => {
      e.preventDefault()
      let formID = upsellAddToCart.closest('form').getAttribute('id')
      this.addItemToCart(formID)
    })
  }

  renderDrawerCart(cart) {
    this.clearCartDrawer()
    let subp = false

    let handles = cart.items.map(function (obj) {
      return obj.handle
    })

    let upsellProduct = this.getUpsellProduct(handles)

    this.getUpsellProductContent(upsellProduct)

    cart.items.forEach((item, index) => {
      let itemVariant = item.variant_title

      if (item.selling_plan_allocation !== undefined) {
        itemVariant = item.selling_plan_allocation.selling_plan.name
        if (subp == false) {
          subp = true
        }
      }

      if (itemVariant === null) {
        itemVariant = ''
      }

      const cartSingleProduct = `
        <div class="go-cart-item__single" data-line="${Number(index + 1)}">
            <div class="go-cart-item__info-wrapper">
              <a href="${
                item.url
              }">  <div class="go-cart-item__image" style="background-image: url(${
        item.image
      });"></div></a>
                <div class="go-cart-item__info">
                    <a href="${item.url}" class="go-cart-item__title">${
        item.product_title
      }</a>
                    <div class="go-cart-item__quantity">
                        <span class="go-cart-item__quantity-label"> </span>
                        <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
                        <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${
                          item.quantity
                        }" disabled>
                        <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
                    </div>
                    <div class="go-cart-item__variant">${itemVariant}</div>
                    <div class="go-cart-item__plans js-selling-plans"></div>
                </div>
            </div>
            <div class="go-cart-item__price">${formatMoney(
              item.line_price,
              this.moneyFormat
            )}</div>
            <a class="go-cart-item__remove ${this.removeFromCartNoDot}"></a>
        </div>`
      this.cartDrawerContent.innerHTML += cartSingleProduct

      const selectedPlan =
        item.selling_plan_allocation !== undefined
          ? item.selling_plan_allocation.selling_plan.name
          : ''
      let has_plans = this.sellingPlanExist(
        item.handle,
        index,
        item.id,
        selectedPlan
      )
    })
    if (subp == true) {
      this.cartDrawer.classList.add('is-rcsms')
    } else {
      this.cartDrawer.classList.remove('is-rcsms')
    }
    this.cartDrawerSubTotal.innerHTML = formatMoney(
      cart.total_price,
      this.moneyFormat
    )
    this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible')
    const removeFromCart = document.querySelectorAll(this.removeFromCart)
    removeFromCart.forEach((item) => {
      item.addEventListener('click', () => {
        GoCart.removeItemAnimation(item.parentNode)
        const line = item.parentNode.getAttribute('data-line')
        this.removeItem(line)
      })
    })
    const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus)
    itemQuantityPlus.forEach((item) => {
      item.addEventListener('click', () => {
        const line =
          item.parentNode.parentNode.parentNode.parentNode.getAttribute(
            'data-line'
          )
        const quantity =
          Number(item.parentNode.querySelector(this.itemQuantity).value) + 1
        this.changeItemQuantity(line, quantity)
      })
    })
    const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus)
    itemQuantityMinus.forEach((item) => {
      item.addEventListener('click', () => {
        const line =
          item.parentNode.parentNode.parentNode.parentNode.getAttribute(
            'data-line'
          )
        const quantity =
          Number(item.parentNode.querySelector(this.itemQuantity).value) - 1
        this.changeItemQuantity(line, quantity)
        if (
          Number(item.parentNode.querySelector(this.itemQuantity).value - 1) ===
          0
        ) {
          GoCart.removeItemAnimation(
            item.parentNode.parentNode.parentNode.parentNode
          )
        }
      })
    })
  }

  sellingPlanExist(handle, index, id, selectedPlan) {
    let line = Number(index + 1)
    let plans = ''

    fetch('/products/' + handle + '.js', {
      credentials: 'same-origin',
      method: 'GET',
    })
      .then((response) => response.json())
      .then((product) => {
        if (product.selling_plan_groups.length > 0) {
          product.selling_plan_groups.forEach((group) => {
            group.selling_plans.forEach((plan) => {
              plans += `<option value="${plan.id}" ${
                plan.name === selectedPlan ? 'selected' : ''
              } ${plan.name === selectedPlan ? 'current-selected' : ''}>${
                plan.name
              }</option>`
            })
          })
        }
        if (selectedPlan !== '') {
          let sellingPlanItem = this.cartDrawerContent.querySelector(
            '[data-line="' + line + '"] .js-selling-plans'
          )
          sellingPlanItem
            .closest('.go-cart-item__single')
            .classList.add('subscription')
          sellingPlanItem.previousElementSibling.style.display = 'none'
          sellingPlanItem.innerHTML = `<select class="js-replace-with-selling-plan" data-variant="${id}">${plans}</select>`
        } else if (
          selectedPlan === '' &&
          product.selling_plan_groups.length > 0
        ) {
          let selling_plan_ID =
            product.selling_plan_groups[0].selling_plans[0].id
          let save_type =
            product.selling_plan_groups[0].selling_plans[0].price_adjustments[0]
              .value_type
          let save =
            product.selling_plan_groups[0].selling_plans[0].price_adjustments[0]
              .value
          if (save_type == 'percentage') {
            var sym = '%'
          } else {
            var sym = '$'
          }
          let sellingPlanItem = this.cartDrawerContent.querySelector(
            '[data-line="' + line + '"] .js-selling-plans'
          )
          let subscribeText = window.stext
          sellingPlanItem
            .closest('.go-cart-item__single')
            .classList.add('subscription')
          sellingPlanItem.innerHTML = `<button class="subscribe-btn js-replace-with-selling-plan js-subscribe-btn" data-variant="${id}" data-plan="${selling_plan_ID}">${subscribeText} ${save}${sym}</button>`
        }
      })
      .catch((error) => {
        throw new Error(error)
      })

    return true
  }

  renderMiniCart(cart) {
    this.clearMiniCart()
    cart.items.forEach((item, index) => {
      let itemVariant = item.variant_title
      if (itemVariant === null) {
        itemVariant = ''
      }
      const cartSingleProduct = `
        <div class="go-cart-item__single" data-line="${Number(index + 1)}">
            <div class="go-cart-item__info-wrapper">
                <div class="go-cart-item__image" style="background-image: url(${
                  item.image
                });"></div>
                <div class="go-cart-item__info">
                    <a href="${item.url}" class="go-cart-item__title">${
        item.product_title
      }</a>
                    <div class="go-cart-item__variant">${itemVariant}</div>
                    <div class="go-cart-item__quantity">
                        <span class="go-cart-item__quantity-label">Quantity: </span>
                        <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
                        <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${
                          item.quantity
                        }" disabled>
                        <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
                    </div>
                </div>
            </div>
            <div class="go-cart-item__price">${formatMoney(
              item.line_price,
              this.moneyFormat
            )}</div>
            <a class="go-cart-item__remove ${
              this.removeFromCartNoDot
            }">Remove</a>
        </div>
      `
      this.cartMiniCartContent.innerHTML += cartSingleProduct
    })
    this.cartMiniCartSubTotal.innerHTML = formatMoney(
      cart.total_price,
      this.moneyFormat
    )
    this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible')
    const removeFromCart = document.querySelectorAll(this.removeFromCart)
    removeFromCart.forEach((item) => {
      item.addEventListener('click', () => {
        GoCart.removeItemAnimation(item.parentNode)
        const line = item.parentNode.getAttribute('data-line')
        this.removeItem(line)
      })
    })
    const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus)
    itemQuantityPlus.forEach((item) => {
      item.addEventListener('click', () => {
        const line =
          item.parentNode.parentNode.parentNode.parentNode.getAttribute(
            'data-line'
          )
        const quantity =
          Number(item.parentNode.querySelector(this.itemQuantity).value) + 1
        this.changeItemQuantity(line, quantity)
      })
    })
    const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus)
    itemQuantityMinus.forEach((item) => {
      item.addEventListener('click', () => {
        const line =
          item.parentNode.parentNode.parentNode.parentNode.getAttribute(
            'data-line'
          )
        const quantity =
          Number(item.parentNode.querySelector(this.itemQuantity).value) - 1
        this.changeItemQuantity(line, quantity)
        if (
          Number(item.parentNode.querySelector(this.itemQuantity).value - 1) ===
          0
        ) {
          GoCart.removeItemAnimation(
            item.parentNode.parentNode.parentNode.parentNode
          )
        }
      })
    })
  }

  renderBlankCartDrawer() {
    this.cartDrawerSubTotal.parentNode.classList.add('is-invisible')
    this.clearCartDrawer()
    this.cartDrawerContent.innerHTML =
      '<div class="go-cart__empty sub-h2">Your cart is empty!</div>'

    this.renderClearCartUpsell()
  }

  renderClearCartUpsell() {
    if (cart_item_count == 0) {
      window.upsellText = 'You might like'
    } else {
      window.upsellText = 'You might also want'
    }
    let el = this.upsellContainer.querySelector('.go-card-also-want__inner')
    let upsellTitle = this.upsellContainer.querySelector('.js-upsell-title')
    if (upsellTitle) {
      upsellTitle.innerHTML = upsellText
    }
    el.innerHTML = ''
    for (let i = 0; i < 2; i++) {
      this.getSingleProductJson(upsellArray[i], el)
    }

    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('js-upsell-add-to-cart')) {
        e.preventDefault()
        let formID = e.target.closest('form').getAttribute('id')
        this.addItemToCart(formID)
      }
    })
  }

  getSingleProductJson(handle, el) {
    fetch('/products/' + handle + '.json', {
      credentials: 'same-origin',
      method: 'GET',
    })
      .then((response) => response.json())
      .then((product) => {
        this.renderSingleUpsellProduct(product.product, el)
      })
  }

  renderSingleUpsellProduct(product, el) {
    let productVariant = product.variants[0]

    const upsellContent = `
      <div class="go-card-also-want__item">
      <a href="/products/${product.handle}">
          <div class="go-card-also-want__image" style="background-image: url(${
            product.image.src
          });">
          </div></a>
          <div class="go-card-also-want__content">
            <a href="/products/${product.handle}" class="title">${
      product.title
    }</a>
            <span class="price">${formatMoney(
              productVariant.price,
              this.moneyFormat
            )}
          </div>
          <form class="upsell" id="upsell_form">
            <input type="hidden"
            name="quantity" value="1" />
            <input type="hidden" name="id" value="${productVariant.id}">
            <div class="go-card-also-want__cta">
                <button class="btn btn--primary js-upsell-add-to-cart">ADD</button>
            </div>
          </form>
          </div>
        </div>
    `
    el.innerHTML += upsellContent
  }

  renderBlankMiniCart() {
    this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible')
    this.clearMiniCart()
    this.cartMiniCartContent.innerHTML =
      '<div class="go-cart__empty">Your cart is empty!</div>'
  }

  clearCartDrawer() {
    this.cartDrawerContent.innerHTML = ''
    //this.upsellContainer.innerHTML = ''
  }

  clearMiniCart() {
    this.cartMiniCartContent.innerHTML = ''
  }

  clearCartModal() {
    this.cartModalContent.innerHTML = ''
  }

  openCartDrawer() {
    this.cartDrawer.classList.add('is-open')
    document.body.classList.add('custom')
  }

  closeCartDrawer() {
    this.cartDrawer.classList.remove('is-open')
    document.body.classList.remove('custom')
  }

  openMiniCart() {
    this.cartMiniCart.classList.add('is-open')
  }

  closeMiniCart() {
    this.cartMiniCart.classList.remove('is-open')
  }

  openFailModal() {
    this.cartModalFail.classList.add('is-open')
  }

  closeFailModal() {
    this.cartModalFail.classList.remove('is-open')
  }

  openCartModal() {
    this.cartModal.classList.add('is-open')
  }

  closeCartModal() {
    this.cartModal.classList.remove('is-open')
  }

  openCartOverlay() {
    this.cartOverlay.classList.add('is-open')
  }

  closeCartOverlay() {
    this.cartOverlay.classList.remove('is-open')
  }

  static removeItemAnimation(item) {
    item.classList.add('is-invisible')
  }

  setDrawerDirection() {
    this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`)
  }
}

new GoCart({
  cartMode: 'drawer', //drawer or mini-cart
  drawerDirection: 'right', //cart drawer from left or right
  displayModal: false, //display success modal when adding product to cart
  moneyFormat: '${{amount}}', //template for money format when displaying money
})
